import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { TaggableChip } from '../../../../display/TaggableChip/TaggableChip';

import {
  getNeedStatus,
  NeedStatus,
} from '../../../../utilities/needs/getNeedStatus.util';
import { Box } from '@mui/material';
import { DueDateAlertIcon } from './DueDateAlertIcon';
import { timeFormatter } from '@act/shared/utilities';
import { determineDateLineTextColor } from '../../utilities';

interface NeedDateLineProps {
  need: NeedDto;
  member: UserDto;
}

export const NeedDateLine = ({ need, member }: NeedDateLineProps) => {
  const dueDate = need.dueDate;

  const needStatus = getNeedStatus(need, member);

  if (needStatus === NeedStatus.StoppedPursuing) {
    return <TaggableChip label="Stopped pursuing" color="warning" isTag />;
  }

  if (needStatus === NeedStatus.Unresolved) {
    return <TaggableChip label="Unresolved" color="error" isTag />;
  }

  const dateColor = determineDateLineTextColor(need, dueDate);

  const formattedDueDate = timeFormatter.epochToShortMonthDay(dueDate);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        paddingRight: '8px',
        ...(dateColor && { color: dateColor }),
      }}
    >
      <DueDateAlertIcon dueDate={dueDate} isCompleted={need.completed} />
      {formattedDueDate}
    </Box>
  );
};
